export default __webpack_public_path__ + "static/media/react.3adc4d15.svg";